import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppShell from './AppShell';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element was not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>,
);
